import React, { useState } from 'react';
import Navbar from './components/Navbar';
import NavOverlay from './components/NavOverlay';
import Sakura from './components/Sakura';
import Loader from './components/Loader';
import GlobalStyle from './globalStyles';
import Hero from './components/Hero';
import { SliderData } from './data/SliderData';
import OurStory from './pages/OurStory';
import Gallery from './pages/Gallery';
import Details from './pages/Details';
import RSVP from './pages/RSVP';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  return (
    <>
      <GlobalStyle />
      {loading && <Loader onDone={() => setLoading(false)} />}
      <Sakura />
      <Navbar onMenuToggle={() => setMenuOpen(m => !m)} isMenuOpen={menuOpen} />
      <NavOverlay isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      <section id="home"><Hero slides={SliderData} /></section>
      <section id="details"><Details /></section>
      <section id="gallery"><Gallery /></section>
      <section id="our-story"><OurStory /></section>
      <section id="rsvp"><RSVP /></section>
    </>
  );
}

export default App;
